import { UserStorageTypes } from '../DataStorageForm/settings';
import { Action, ActionType, GetDataPayload, UserState } from './types';

export const initialState: UserState = {
  saveDataFetching: false,
  resetPasswordFetching: false,
  newEmailFetching: false,
  resendEmailFetching: false,
  newPhoneFetching: false,
  unbanFetching: false,
  newEmail: '',
  emailTaken: '',
  newPhone: '',
  phoneEdit: false,
  emailEdit: false,
  isXsollaStorage: false,
  isChangingEmailAllowed: false,
  user: {},
  groups: [],
  emailError: '',
  phoneError: '',
  submitError: '',
  newServerCustomId: '',
  serverCustomIdError: '',
  serverCustomIdEdit: false,
  newServerCustomIdFetching: false
};

export const userReducer = (state: UserState, action: Action): UserState => {
  switch (action.type) {
    case ActionType.resetPasswordStart:
      return {
        ...state,
        resetPasswordFetching: true
      };
    case ActionType.resetPasswordEnd:
      return {
        ...state,
        resetPasswordFetching: false
      };
    case ActionType.banUserEnd:
      return {
        ...state,
        user: {
          ...state.user,
          ban: action.payload
        }
      };
    case ActionType.unbanUserStart:
      return {
        ...state,
        unbanFetching: true
      };
    case ActionType.unbanUserEnd:
      return {
        ...state,
        unbanFetching: false,
        user: {
          ...state.user,
          ban: null
        }
      };
    case ActionType.resendEmailStart:
      return { ...state, resendEmailFetching: true };
    case ActionType.resendEmailEnd:
      return { ...state, resendEmailFetching: false };
    case ActionType.emailEditToggle:
      return {
        ...state,
        emailEdit: !state.emailEdit
      };
    case ActionType.changeEmail:
      return { ...state, newEmail: action.payload };
    case ActionType.changeEmailError:
      return { ...state, emailError: action.payload };
    case ActionType.changeEmailStart:
      return { ...state, newEmailFetching: true, emailError: '' };
    case ActionType.changeEmailForceUnlink:
      return { ...state, emailTaken: action.payload };
    case ActionType.changeEmailEnd:
      return {
        ...state,
        newEmailFetching: false
      };
    case ActionType.phoneEditToggle:
      return { ...state, phoneEdit: !state.phoneEdit };
    case ActionType.changePhone:
      return { ...state, newPhone: action.payload };
    case ActionType.changePhoneError:
      return { ...state, phoneError: action.payload };
    case ActionType.changePhoneStart:
      return { ...state, newPhoneFetching: true, phoneError: '' };
    case ActionType.changePhoneEnd:
      return { ...state, newPhoneFetching: false };
    case ActionType.submitStart:
      return { ...state, saveDataFetching: true, submitError: '' };
    case ActionType.submitSuccess:
      return {
        ...state,
        saveDataFetching: false,
        user: {
          ...state.user,
          groups: action.payload
        }
      };
    case ActionType.submitFail:
      return { ...state, saveDataFetching: false, submitError: action.payload };
    case ActionType.changeServerCustomId:
      return { ...state, newServerCustomId: action.payload };
    case ActionType.changeServerCustomIdError:
      return { ...state, serverCustomIdError: action.payload };
    case ActionType.changeServerCustomIdStart:
      return { ...state, newServerCustomIdFetching: true, serverCustomIdError: '' };
    case ActionType.changeServerCustomIdEnd:
      return { ...state, newServerCustomIdFetching: false };
    case ActionType.serverCustomIdEditToggle:
      return { ...state, serverCustomIdEdit: !state.serverCustomIdEdit };
    default:
      throw new Error('Unknown action type in User reducer!');
  }
};

export const init = ({ user, groups, configuration }: GetDataPayload): UserState => {
  return {
    ...initialState,
    user,
    groups,
    newEmail: user.email,
    newPhone: user.phone_auth || '',
    newServerCustomId: user.server_custom_id || '',
    isXsollaStorage: configuration?.users_storage === UserStorageTypes.xsolla,
    isChangingEmailAllowed:
      configuration?.users_storage !== UserStorageTypes.playfab &&
      configuration?.users_storage !== UserStorageTypes.firebase
  };
};
